module.exports = __webpack_public_path__ + "static/media/tammy.0b1bf508.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/tammy.png
// module id = 331
// module chunks = 0